import React from 'react';
import { Card, Button, Typography, Space } from 'antd';
import { ShoppingCartOutlined, GiftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const TemuBanner = () => {
    const { i18n } = useTranslation();
    const isRu = i18n.language === 'ru';

    return (
        <Card
            style={{
                marginBottom: 20,
                borderRadius: 15,
                background: 'linear-gradient(135deg, #ff6000 0%, #ff9000 100%)',
                border: 'none',
                boxShadow: '0 4px 12px rgba(255, 96, 0, 0.25)',
                color: 'white',
                overflow: 'hidden'
            }}
            bodyStyle={{ padding: '20px' }}
        >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 15 }}>
                <Space align="start" size="middle">
                    <div style={{ 
                        background: 'rgba(255,255,255,0.2)', 
                        padding: '12px', 
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <ShoppingCartOutlined style={{ fontSize: 32, color: 'white' }} />
                    </div>
                    <div>
                        <Title level={4} style={{ color: 'white', margin: 0 }}>
                            {isRu ? 'Купон на 40,000 драм от Temu' : '40,000 դրամի նվեր-կտրոն Temu-ից'}
                        </Title>
                        <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: 14 }}>
                            {isRu 
                                ? 'Нажмите и зарегистрируйтесь, чтобы получить купон и поддержать наш проект! Это как покупки в бездонной яме — вы никогда не захотите останавливаться! :)' 
                                : 'Ստացեք 40,000 դրամի կուպոն և վայելեք անվերջ գնումների աշխարհը: Գրանցվեք և աջակցեք մեր նախագծին :)'}
                        </Text>
                    </div>
                </Space>
                <Button 
                    type="primary" 
                    size="large" 
                    href="https://temu.to/k/emxfppzel5v" 
                    target="_blank"
                    style={{ 
                        borderRadius: 8, 
                        fontWeight: 'bold', 
                        height: '45px',
                        background: '#ffffff',
                        borderColor: '#ffffff',
                        color: '#ff6000'
                    }}
                    icon={<GiftOutlined />}
                >
                    {isRu ? 'Получить купон' : 'Ստանալ կտրոնը'}
                </Button>
            </div>
        </Card>
    );
};

export default TemuBanner;
